import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'unitExtractor',
  standalone: false,
})
export class UnitExtractorPipe implements PipeTransform {
  transform(value: string): number | null {
    if (!value) return null;
    const numericValue = value.replace(/(px|em|rem)/g, '').trim();
    return parseFloat(numericValue);
  }
}
